module.exports = __webpack_public_path__ + "img/img2.2c928b48.png";